<template>
  <legal-document-view slug="privacy-policy" />
</template>

<script setup lang="ts">
/**
 * Политика конфиденциальности.
 *
 * Адрес намеренно оставлен на верхнем уровне, а не переведён в /documents:
 * он проиндексирован и на него ссылаются извне. Остальные юридические
 * документы живут под /documents/<slug>.
 *
 * Текст больше не захардкожен в шаблоне (было 482 строки разметки), а
 * приходит из Strapi: правки вносят юристы через админку, без выкатки,
 * и каждая публикация сохраняется отдельной редакцией. Содержимое взято
 * с прода, а не из исходного .docx — страницу верстали по документу, но
 * по дороге отредактировали, и правки эти нужные.
 */
</script>
